import { NavLink, Outlet } from "react-router-dom";

const TABS = [
  { to: "/admin/members",   label: "회원",   end: true },
  { to: "/admin/products",  label: "상품" },
  { to: "/admin/suppliers", label: "매입처" },
  { to: "/admin/orders",    label: "주문" },
  { to: "/admin/payments",  label: "결제" },
  { to: "/admin/stock",     label: "재고" },
  { to: "/admin/import",    label: "임포트" },
];

export default function AdminLayout() {
  return (
    <main id="main-content" className="container" style={{ padding: "var(--s-6) var(--s-5) var(--s-10)" }}>
      <header style={{ marginBottom: "var(--s-5)" }}>
        <p className="eyebrow" style={{ marginBottom: 4 }}>Studio Admin</p>
        <h1 className="h-title">관리자</h1>
      </header>

      <nav className="admin-tabs" aria-label="관리자 메뉴" style={{ display: "flex", gap: 4, marginBottom: "var(--s-5)", padding: 4, background: "var(--bg-subtle)", borderRadius: "var(--r-md)", overflowX: "auto", scrollbarWidth: "none" }}>
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) => `admin-tab ${isActive ? "is-active" : ""}`}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />

      <style>{`
        .admin-tabs::-webkit-scrollbar { display: none; }
        .admin-tab {
          padding: 8px 14px;
          font-size: 13px;
          font-weight: 600;
          color: var(--text-muted);
          border-radius: var(--r-sm);
          white-space: nowrap;
          transition: background var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out);
        }
        .admin-tab:hover { color: var(--text); background: var(--surface); }
        .admin-tab.is-active {
          background: var(--surface);
          color: var(--primary);
          box-shadow: var(--shadow-xs);
        }
      `}</style>
    </main>
  );
}
